import {getCookie} from "../utils/utils";

export default class Modal {
	constructor() {
		this.modalOpeners 		= document.querySelectorAll('[data-modal]');
		this.modalClosers       = document.querySelectorAll('[data-modalcloser]');

		this.modalOpeners && this.modalOpeners.forEach( (modalOpener) => {
			modalOpener.addEventListener("click", (event) => {
				this.modalOpener(modalOpener);
			});

			const modalContainer = modalOpener.closest('.modal--sticky-modal')

			if (modalContainer.classList.contains('modal--whats-new') && !modalContainer.classList.contains('modal--open')) {
				setTimeout(() => {
					this.modalOpener(modalOpener);
				}, 3000);
			}
		});

		this.modalClosers && this.modalClosers.forEach( (modalCloser) => {
			modalCloser.addEventListener("click", (event) => {
				this.modalCloser(modalCloser);
			});
		});

		// Logic for sticky/side/slide out modals
		// this.slideModals = document.querySelectorAll('.modal--sticky-modal');
		//
		// this.slideModals && this.slideModals.forEach((slideModal) => {
		// 	// Initially set the height of each modal as the height of the title
		// 	this.titleHeight = slideModal.querySelector('.modal__title').offsetHeight;
		// 	slideModal.style.height = this.titleHeight+'px';
		//
		// 	slideModal.addEventListener("click", (event) => {
		// 		if(slideModal.classList.contains('modal--open')) {
		// 			this.textHeight = slideModal.querySelector('.modal__text-area').offsetHeight;
		// 			slideModal.style.height = this.textHeight+'px';
		// 		} else {
		// 			this.titleHeight = slideModal.querySelector('.modal__title').offsetHeight;
		// 			setTimeout(() => {
		// 				slideModal.style.height = this.titleHeight+'px';
		// 			}, 250);
		// 		}
		// 	});
		//
		// 	const defaultTitleHeight = slideModal.querySelector('.modal__title').offsetHeight;
		//
		// 	slideModal.addEventListener("mouseover", (event) => {
		// 		if(!slideModal.classList.contains('modal--open')) {
		// 			this.textHeight = slideModal.querySelector('.modal__text-area').offsetHeight;
		// 			slideModal.style.height = this.textHeight + 'px';
		// 			slideModal.querySelector('.modal__title').style.height = this.textHeight + 'px';
		// 		}
		// 	});
		//
		// 	slideModal.addEventListener("mouseleave", (event) => {
		// 		if(!slideModal.classList.contains('modal--open')) {
		// 			slideModal.style.height = defaultTitleHeight + 'px';
		// 			slideModal.querySelector('.modal__title').style.height = defaultTitleHeight + 'px';
		// 		}
		// 	});
		// });
	}

	modalOpener(modalOpener) {
		// Get the modal size
		this.modalSize = modalOpener.dataset.modal;
		if(this.modalSize === 'large') {
			// If large modal (e.g. contact form success)
			document.body.classList.add("modal--large-open");
		} else {
			// If any other/small modal (e.g. newsletter)
			let modalToOpen = modalOpener.closest('.modal--sticky-modal');
			modalToOpen.classList.toggle('modal--open');
			let stickyModals = document.querySelectorAll('.modal--sticky-modal');
			stickyModals.forEach((stickyModal) => {
				if(!stickyModal.isEqualNode(modalToOpen)) {
					stickyModal.classList.remove('modal--open');
				}
			});
		}
	}

	modalCloser(modalCloser) {
		this.modalSize = modalCloser.dataset.modalcloser;
		if(this.modalSize === 'large') {
			document.body.classList.remove("modal--large-open");
		} else {
			// If any other/small modal (e.g. newsletter)
			let modalToClose = modalCloser.closest('.modal--sticky-modal')
			document.body.classList.remove("modal--large-open");
			modalToClose.classList.remove('modal--open');
			modalToClose.classList.add('modal--hidden');
			let lastClosed = (modalToClose.dataset.id);
			let currentlyClosed = getCookie('stickyModals');
			let arrayOfClosed = [];

			// Remove/hide modal when fully closed/hidden
			// This allows the other modals to fall into the empty space
			setTimeout(() => {
				modalToClose.style.display = "none";
			}, 250)

			if(currentlyClosed) {
				// If already closed modals then add the newly closed modal to the cookie array
				let closedModals = [];
				currentlyClosed = JSON.parse(currentlyClosed);
				currentlyClosed.forEach((closedModal) => {
					closedModals.push(closedModal);
				});
				closedModals.push(lastClosed);
				arrayOfClosed = JSON.stringify(closedModals);
			} else {
				// If none closed already, assign the initial closed to the cookie
				arrayOfClosed = JSON.stringify([lastClosed]);
			}
			document.cookie = "stickyModals=" +arrayOfClosed+"; expires=Thu, 01 Jan 2099 00:00:01 GMT;"+"; path=/";
		}
	}
}